// client/src/lib/roles.js
// Mirrors src/lib/roles.js. RGA Partner (a person with a partnership
// agreement with RGA) and Partner Firm (a firm RGA partners with on a
// mandate) are unrelated; both used to be stored as 'Partner Advisor',
// renamed by migration 059.

import { useQuery } from '@tanstack/react-query'
import api from './api'

export const RGA_PARTNER  = 'RGA Partner'
export const PARTNER_FIRM = 'Partner Firm'
// Set only by deactivating an RGA user (Settings -> Team & Access), never
// offered in forms; a valid stored value all the same.
export const FORMER_RGA_TEAM = 'Former RGA Team'

// The checkbox options for contact and firm types, used by every form.
// (Former RGA Team is deliberately absent; see FORMER_RGA_TEAM.)
export const CONTACT_TYPES = [
  'Investor', 'GP', RGA_PARTNER, 'Deal Source', 'Business Development',
  'Service Provider', 'RGA Team',
]
export const FIRM_TYPES = ['GP Client', 'LP / Investor', PARTNER_FIRM, 'Service Provider', 'Other']

const has = (list, value) => Array.isArray(list) && list.includes(value)
export const isRgaPartner  = contact => has(contact?.contact_type, RGA_PARTNER)
export const isPartnerFirm = firm    => has(firm?.firm_type, PARTNER_FIRM)

// The allowed values, as managed by admins in Settings -> Roles (role_options,
// migration 064). Falls back to the built-in lists above while loading.
//   contactTypes / firmTypes        — offered as checkboxes in forms
//   allContactTypes / allFirmTypes  — every standard value, incl. system ones
//                                     like Former RGA Team (for filters)
export function useRoleOptions() {
  const { data } = useQuery({
    queryKey: ['role-options'],
    queryFn: () => api.get('/api/roles').then(r => r.data.data),
    staleTime: 5 * 60 * 1000,
  })
  const values = (kind, formsOnly) => (data?.[kind] ?? [])
    .filter(r => r.standard && (!formsOnly || r.in_forms)).map(r => r.value)
  return data
    ? { contactTypes: values('contact', true), firmTypes: values('firm', true),
        allContactTypes: values('contact', false), allFirmTypes: values('firm', false) }
    : { contactTypes: CONTACT_TYPES, firmTypes: FIRM_TYPES,
        allContactTypes: [...CONTACT_TYPES, FORMER_RGA_TEAM], allFirmTypes: FIRM_TYPES }
}
